import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ChevronDown } from "lucide-react";

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);

  const languages = [
    { code: "fr", label: "Français" },
    { code: "ar", label: "العربية" },
    { code: "en", label: "English" },
  ];

  const currentLanguage =
    languages.find((lang) => lang.code === i18n.language) || languages[0];

  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
    localStorage.setItem("language", language);
    setOpen(false);
  };

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="
          flex items-center gap-1
          px-2 py-1
          rounded-md
          border border-black/10
          hover:border-primary
          transition
          text-[10px] sm:text-[11px]
          font-semibold
          whitespace-nowrap
        "
      >
        <span>{currentLanguage.code.toUpperCase()}</span>

        <ChevronDown
          size={11}
          className={`transition-transform ${
            open ? "rotate-180" : ""
          }`}
        />
      </button>

      {open && (
        <div className="absolute right-0 top-full mt-2 w-28 bg-white border border-black/10 rounded-lg shadow-lg py-1 z-[200]">
          {languages.map((language) => (
            <button
              key={language.code}
              type="button"
              onClick={() => changeLanguage(language.code)}
              className={`w-full flex items-center justify-between px-3 py-2 text-[11px] text-left hover:bg-black/5 transition ${
                i18n.language === language.code
                  ? "text-primary font-semibold"
                  : "text-black"
              }`}
            >
              <span>{language.code.toUpperCase()}</span>
              <span>{language.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}